export default {
  SET_COMPANY_BRANDING
};

function SET_COMPANY_BRANDING(state, payload) {
  if (payload?.sidebarColor !== undefined) {
    state.sidebarColor = payload.sidebarColor;
  }
  if (payload?.sidebarLogo !== undefined) {
    state.sidebarLogo = payload.sidebarLogo;
  }
}
